import { Modal as ModalModule } from 'common';
import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import TransactionConfirmationContent from './TransactionConfirmationContent.component';

const { Modal, ModalButtonActionType } = ModalModule;

const TransactionConfirmationModal = ({
	data: { locationRows, responseData },
	modalId,
}) => {
	const componentRef = useRef(null);

	return (
		<Modal
			modalId={modalId}
			className="account-allocate-funds transaction-confirmation-modal"
			header="Transaction Confirmation"
			primaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Done',
			}}
			secondaryButton={{
				type: ModalButtonActionType.Ok,
				onClick: () => {
					document.getElementById('printTrigger').click();
				},
				text: 'Print',
			}}
		>
			<ReactToPrint
				trigger={() => <button id="printTrigger" />}
				content={() => componentRef.current}
			/>
			<TransactionConfirmationContent
				ref={componentRef}
				responseData={responseData}
				locationRows={locationRows}
			/>
		</Modal>
	);
};

export default TransactionConfirmationModal;
